import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Los bundlers rompen la resolución por defecto de los íconos de Leaflet
// (busca las imágenes por una ruta relativa que no existe en el build) — este
// fix es el recomendado por la librería. Efecto colateral global, se importa
// una sola vez por página que use un mapa.
delete (L.Icon.Default.prototype as unknown as { _getIconUrl?: unknown })._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});
